<template>
  <div class="finish-popup-con">
    <div class="container">
      <span class="close" v-on:click="onClose"/>
      <h3>Your order has been allocated<br>
        Click here to continue</h3>
      <div class="button-con">
        <CButton color="green" text="Continue" @click="onContinueClick"/>
      </div>
    </div>
  </div>
</template>

<script>
import CButton from "../common/CButton.vue";
import CSwitch from "../common/CSwitch.vue";
import {VueGoodTable} from 'vue-good-table';

export default {
  name: 'FinishAllocationPopup',
  components: {
    CButton,
  },
  props: {
    onContinueClick: Function,
    onClose: Function
  },
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {
  }
}
</script>